var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #3d4e92;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    className: "cls-1",
    d: "M20,2.91c9.44,0,17.09,7.65,17.09,17.09s-7.65,17.09-17.09,17.09S2.91,29.44,2.91,20h0c0-9.44,7.65-17.09,17.09-17.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    className: "cls-2",
    d: "M20,11.18c2.87,0,3.22.01,4.35.06.68,0,1.36.13,2,.37.94.36,1.68,1.1,2.04,2.04.24.64.36,1.32.37,2,.05,1.13.06,1.48.06,4.35s-.01,3.22-.06,4.35c0,.68-.13,1.36-.37,2-.36.94-1.1,1.68-2.04,2.04-.64.24-1.32.36-2,.37-1.13.05-1.47.06-4.35.06s-3.22-.01-4.35-.06c-.68,0-1.36-.13-2-.37-.94-.36-1.68-1.1-2.04-2.04-.24-.64-.36-1.32-.37-2-.05-1.13-.06-1.48-.06-4.35s.01-3.22.06-4.35c0-.68.13-1.36.37-2,.36-.94,1.1-1.68,2.04-2.04.64-.24,1.32-.36,2-.37,1.13-.05,1.48-.06,4.35-.06M20,9.24c-2.92,0-3.29.01-4.44.06-.89.02-1.78.19-2.61.5-1.45.56-2.59,1.7-3.15,3.15-.31.84-.48,1.72-.5,2.61-.05,1.15-.07,1.52-.07,4.44s.01,3.29.06,4.44c.02.89.19,1.78.5,2.61.56,1.45,1.7,2.59,3.15,3.15.84.31,1.72.48,2.61.5,1.15.05,1.51.06,4.44.06s3.29-.01,4.44-.06c.89-.02,1.78-.19,2.61-.5,1.45-.56,2.59-1.7,3.15-3.15.31-.84.48-1.72.5-2.61.05-1.15.06-1.51.06-4.44s-.01-3.29-.06-4.44c-.02-.89-.19-1.78-.5-2.61-.56-1.45-1.7-2.59-3.15-3.15-.84-.31-1.72-.48-2.61-.5-1.15-.05-1.51-.06-4.44-.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    className: "cls-2",
    d: "M20,14.47c-3.05,0-5.52,2.47-5.52,5.52s2.47,5.52,5.52,5.52,5.52-2.47,5.52-5.52-2.47-5.52-5.52-5.52h0M20,23.59c-1.98,0-3.59-1.61-3.59-3.59s1.61-3.59,3.59-3.59,3.59,1.61,3.59,3.59c0,1.98-1.61,3.59-3.59,3.59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    className: "cls-2",
    d: "M27.04,14.26c0,.71-.58,1.29-1.29,1.29-.71,0-1.29-.58-1.29-1.29s.58-1.29,1.29-1.29h0c.71,0,1.29.58,1.29,1.29h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlanco);
export default __webpack_public_path__ + "static/media/instagramBlanco.875af57d1acedfc6813cc2a4fc7c62c5.svg";
export { ForwardRef as ReactComponent };